import React, { useRef, useState } from 'react'
import { useDispatch } from 'react-redux';


export default function useHandleOrder(refrence) {
    const props = refrence || { type: "0", url: 'rul needed' };
    const { type, url, setList, list, databaseList } = props;
    // const [Component, setComponent] = useState(<React.Fragment></React.Fragment>)

    const dispatch = useDispatch();
    const dragItem = useRef();

    const dragOverItem = useRef();
    const dragStart = (e, position) => dragItem.current = position;

    const dragEnter = (e, position) => dragOverItem.current = position;

    const drop = (e) => {
        const copyListItems = [...list];
        const dragItemContent = copyListItems[dragItem.current];
        copyListItems?.splice(dragItem.current, 1);
        copyListItems?.splice(dragOverItem.current, 0, dragItemContent);
        dragItem.current = null;
        dragOverItem.current = null;
        const data = copyListItems.map((item, index) => {
            return { ...item, order: index + 1 }
        })
        setList(data);
    };

    const isDataUpdated = () => {
        if (databaseList?.length === list?.length) {
            return databaseList?.every((item, index) => {
                return item?.id === list[index].id
            })
        }
        return false
    }
    const isAllParetcategoriesIdSame = list?.every((item, index) => item?.parentCategoryId === list[0]?.parentCategoryId)

    return { dragItem, dragOverItem, dragStart, dragEnter, drop, isAllParetcategoriesIdSame, isDataUpdated }
}

